<template>
  <div class="tempus-iframe-customer-container">
    <div class="container py-4">

      <div class="mb-4">
        <button class="calendarWeekGrid_Button_PrevNext" @click="backToCalendar">
          <span class="material-icons">arrow_back</span>
          <p class="mb-0">Back To Calendar</p>
        </button>
        <button v-if="showDetails" class="calendarWeekGrid_Button_PrevNext" @click="backToPurchaseDetails">
          <span class="material-icons">arrow_back</span>
          <p class="mb-0">Back To Purchase Details</p>
        </button>

        <button v-if="selectedCustomer && cart && cart.cart_items.length" class="calendarWeekGrid_Button_PrevNext" @click="forwardToCheckout">
          <span class="material-icons">arrow_forward</span>
          <p class="mb-0">To Checkout</p>
        </button>
      </div>

      <h4 :class="$deploymentIs('cryptology') ? 'font-mon' : ''" :style="$deploymentIn(['breakescape', 'taketheexit']) ? 'letter-spacing: 0;' : ''">Your Details</h4>

      <div class="tempus-iframe-div-box-shadow tempus-iframe-form">
        <div class="row">
          <div class="col-sm-12 col-xl-6">
            <div class="form-group row">
              <label :for="$id('email')" class="col-sm-4 col-xl-3 col-form-label pt-0"><sup class="text-tempus-red font-weight-bold" data-toggle="tooltip" title="Required">(*)</sup> Email</label>
              <div class="col-sm-8 col-xl-9">
                <input type="email"
                  :id="$id('email')"
                  class="form-control"
                  :class="{'is-invalid': emailError}"
                  :disabled="cartEmptyAndSaleHappening"
                  placeholder="If you have already booked before, your email will populate the rest"
                  v-model="email"
                  @blur='emailBlur'
                  autocomplete="email"
                  required>
                <div v-if="emailError" class="invalid-feedback d-block" role="alert">{{ emailError }}</div>
                <div v-if="emailSoftError" class="text-orange font-weight-bold d-block" role="alert">{{ emailSoftError }}</div>
              </div>
            </div>
          </div>

          <div class="col-sm-12 col-xl-6">
            <div class="form-group row">
              <label :for="$id('name')" class="col-sm-4 col-xl-3 col-form-label pt-0"><sup class="text-tempus-red font-weight-bold" data-toggle="tooltip" title="Required">(*)</sup> Name</label>
              <div class="col-sm-8 col-xl-9">
                <input type="text"
                  :id="$id('name')"
                  ref="nameInput"
                  class="form-control"
                  :class="{'is-invalid': nameError}"
                  :disabled="cartEmptyAndSaleHappening"
                  v-model="name"
                  placeholder="Full name for booking"
                  autocomplete="name"
                  required>
                <div v-if="nameError" class="invalid-feedback d-block" role="alert">{{ nameError }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 col-xl-6">
            <div class="form-group row" style="display: none;">
              <label :for="$id('username')" class="col-sm-4 col-xl-3 col-form-label"><sup class="text-tempus-red font-weight-bold" data-toggle="tooltip" title="Required">(*)</sup> Username</label>
              <div class="col-sm-8 col-xl-9">
                <input
                  type="text"
                  :id="$id('username')"
                  class="form-control"
                  v-model="username"
                  placeholder="Username"
                  autocomplete="off">
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 col-xl-6">
            <div class="form-group row">
              <label :for="$id('contactNumber')" class="col-sm-4 col-xl-3 col-form-label pt-0">
                <sup
                  v-if="this.location.formCustomerNumberRequired"
                  class="text-tempus-red font-weight-bold"
                  data-toggle="tooltip"
                  title="Required">
                  (*)
                </sup>
                 Contact Number
               </label>
              <div class="col-sm-8 col-xl-9">
                <input type="tel"
                  :id="$id('contactNumber')"
                  ref="customerTelephoneInput"
                  class="form-control"
                  :class="{'is-invalid': contactNumberError}"
                  :disabled="cartEmptyAndSaleHappening"
                  v-model="contactNumber"
                  placeholder="Contact number"
                  autocomplete="tel"
                  required>
                <div v-if="contactNumberError" class="invalid-feedback d-block" role="alert">{{ contactNumberError }}</div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="true || customerRequestMarketingPermission" class="form-group row">
          <div class="checkboxdiv ml-2">
            <label :for="$id('marketing_consent')" class="ml-2">I give consent to receive additional marketing</label>
            <label class="checkboxdiv-label-md ml-2">
              <input
                type="checkbox"
                :id="$id('marketing_consent')"
                :disabled="cartEmptyAndSaleHappening"
                v-model="marketingConsent">
              <span class="cr"><span class="cr-icon">&#10004;</span></span>
            </label>
          </div>
        </div>

        <template v-if="cartEmptyAndSaleHappening"><!-- THIS SHOULD ONLY BE VISIBLE IF THE CART IS CONVERTED TO A SALE AND IT IS UNDER WAY --></template>
        <template v-else>
          <div v-if="cart && cart.customer && cart.customer.id" class="row">
            <div class="col btn-group">
              <button class="btn btn-lg btn-orange" @click="removeCustomerFromCart">Remove Me From This Cart <span class="material-icons" style="position: relative; top: 6px;">person_remove</span></button>
              <button v-if="cart.cart_items.length" class="btn btn-lg btn-red" @click="emptyCart">Empty Cart <span class="material-icons" style="position: relative; top: 5px;">remove_shopping_cart</span></button>
            </div>
          </div>
          <div v-if="cart && cart.customer === null" class="row">
            <div class="col btn-group">
              <button :disabled="! this.email || ! this.name" class="btn btn-lg btn-dark-green" @click="addCustomerToCart">Add Me As The Cart Customer <span class="material-icons" style="position: relative; top: 6px;">person_add</span></button>
              <button v-if="cart.cart_items.length" class="btn btn-lg btn-red" @click="emptyCart">Empty Cart <span class="material-icons" style="position: relative; top: 5px;">remove_shopping_cart</span></button>
            </div>
          </div>
          <div v-else-if="! selectedCustomer && this.email && this.name" class="row">
            <div class="col btn-group">
              <button class="btn btn-lg btn-dark-green" @click="addCustomerToCart">Continue <span class="material-icons" style="position: relative; top: 6px;">person_add</span></button>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>

</template>

<script>
import {Address} from 'address-rfc2821';

export default {
  props: {
    consoleDebug: {
      type: Boolean,
      default: false,
    },
    location: {
      type: Object,
      required: true,
    },
    customerRequestMarketingPermission: {
      type: Boolean,
    },
    locationChildPricing: {
      type: Boolean,
    },
    selectedCustomer: {
      type: Object,
    },
    showDetails: {
      type: Boolean,
    },
  },

  data() {
    return {
      email: null,
      name: null,
      username: null, // for spam detection
      contactNumber: null,
      marketingConsent: false,

      // validation errors
      emailError: false,
      emailSoftError: false,
      nameError: false,

      awaitingCartUpdate: false,
      cart: null,
      sale: null,

      fetchingCustomer: false,
    };
  },

  watch: {
    selectedCustomer: {
      handler(newCustomer) {
        if (this.consoleDebug) console.log('BookingCheckoutIframeCustomer::watch selectedCustomer', newCustomer);
        this.selectSelectedCustomer(newCustomer);
      },
      // deep: true,
    },

    sale: {
      handler(newSale) {
        if (this.consoleDebug) console.log('BookingCheckoutIframeCustomer::watch sale', newSale);
        this.selectSelectedCustomer(newSale.customer);
      },
      // deep: true,
    },
  },

  computed: {
    contactNumberError() {
      if (this.location.formCustomerNumberRequired === false && this.contactNumber === null) {
        return null;
      } else {
        if (this.contactNumber == '***** ******') {
          return null;
        } else {
          if (this.contactNumber && this.contactNumber
            .match(/^(?:(?:\(?(?:0(?:0|11)\)?[\s-]?\(?|\+)44\)?[\s-]?(?:\(?0\)?[\s-]?)?)|(?:\(?0))(?:(?:\d{5}\)?[\s-]?\d{4,5})|(?:\d{4}\)?[\s-]?(?:\d{5}|\d{3}[\s-]?\d{3}))|(?:\d{3}\)?[\s-]?\d{3}[\s-]?\d{3,4})|(?:\d{2}\)?[\s-]?\d{4}[\s-]?\d{4}))(?:[\s-]?(?:x|ext\.?|\#)\d{3,4})?$/)
            // [3]
            // .replace(/ /g,'').match(/^((1[1-9]|2[03489]|3[0347]|5[56]|7[04-9]|8[047]|9[018])\d{8}|(1[2-9]\d|[58]00)\d{6}|8(001111|45464\d))$/)
            ) {
            return null;
          } else {
            return 'Possible invalid phone number.';
          }
        }
      }
    },

    cartEmptyAndSaleHappening() {
      if (this.cart === null) {

      }
      if (this.cart && this.cart.cart_items.length == 0 && this.sale) {
        return true;
      }
      return false;
    },

  },

  methods: {
    saleRefreshed(sale) {
      if (this.consoleDebug) console.log('BookingCheckoutIframeCustomer::saleRefreshed', sale);
      this.sale = sale;
    },

    backToCalendar() {
      this.$emit('back-to-calendar');
    },
    backToPurchaseDetails() {
      this.$emit('back-to-purchase-details');
    },
    forwardToCheckout() {
      this.$emit('back-to-checkout');
    },

    addCustomerToCart() {
      if (this.consoleDebug) console.log('BookingCheckoutIframeCustomer::addCustomerToCart()');
      // Validation
      if (this.email == null || this.email == '') {
        this.emailError = 'An email address is required.'; // Please enter a valid email address.
      } else {
        this.emailError = false;
        this.emailSoftError = false;

        try {
          new Address(this.email);
        } catch (error) {
          this.emailError = error.message; // Please enter a valid email address.
        }

        // TODO: try looking up the email again?
        this.loading(true);
        this.searchEmail(this.email)
          .then(customerFound => {
            this.loading(false);
            if (customerFound !== null) {
              if (this.name != customerFound.name || this.contactNumber != '***** ******') {
                // TODO: should we update the Customer details?
                // this.updateCustomer();
              }

              this.$emit('customer-selected', customerFound);
              if (this.consoleDebug) console.log('BookingCheckoutIframeCustomer::addCustomerToCart emitted customer-selected', customerFound);
              return true;
            } else {
              this.checkRegionalEmail();
            }
          });
      }

      if (this.name == null || this.name == '') {
        this.nameError = 'Please enter your name.';
      } else {
        this.nameError = false;
      }

      if (this.location.formCustomerNumberRequired && this.contactNumberError !== null) {
        this.numberError = 'Possible number error.';
        this.$refs.customerTelephoneInput.focus()
        this.numberError = false;
      } else {
        this.numberError = false;
      }

      if (this.emailError
        || this.nameError
        || this.numberError) {
        flash('Customer data is missing', 'danger');
        return false;
      }

      if (this.consoleDebug) console.log('BookingCheckoutIframeCustomer::addCustomerToCart about to store Customer');
      this.loading(true);
      this.storeCustomer()
        .then(newCustomer => {
          if (this.consoleDebug) console.log('BookingCheckoutIframeCustomer::addCustomerToCart() - this.storeCustomer().then(...)');
          if (this.consoleDebug) console.log('BookingCheckoutIframeCustomer::addCustomerToCart() - newCustomer:', newCustomer);
          this.loading(false);
          if (newCustomer) {
            this.$emit('customer-selected', newCustomer);
          } else {
            if (this.consoleDebug) console.log('BookingCheckoutIframeCustomer::addCustomerToCart() - ! newCustomer')
            // this.payButtonDisable = false;
            return; // some kind of error cause we failed to create the customer
          }
        });
    },

    async storeCustomer() {
      // create the customer
      let request = {
        email: this.email,
        name: this.name,
        number: this.contactNumber,
        location_id: this.location.id,
        no_mail: this.marketingConsent == true ? 0 : 1, // the logic is flipped as we want no_mail in the db
      }
      if (this.consoleDebug) console.log('BookingCheckoutIframeCustomer::storeCustomer', request);

      try {
        const response = await axios.post(this.route('api.customers.store'), request)
        if (response.status == 200) {
          return response.data;
        } else {
          flash('Error creating customer', 'danger');
          if (this.consoleDebug) console.log('BookingCheckoutIframeCustomer::storeCustomer - data', response.data);
          if (this.consoleDebug) console.log('BookingCheckoutIframeCustomer::storeCustomer - status', response.status);
          if (this.consoleDebug) console.log('BookingCheckoutIframeCustomer::storeCustomer - statusText', response.statusText);
        }
      } catch (error) {
        // flash('Error creating customer', 'danger');
        if (error.response) {
          if (error.response.status == 422) {
            // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
            console.log('storeCustomer:422', error.response.data);
            // TODO: if The email has already been taken. ???
            if (error.response.data.errors.number) {
              this.loading(false);
              flash('Phone number invalid, cannot proceed ' + error.response.data.errors.number[0]);
             // this.contactNumberError = 'Number is invalid, please resolve.';
              this.$ref.customerTelephoneInput.focus();
            } else {
              this.loading(false);
              flash('Unable to store customer. Please check details.');
            }
          } else if (error.response.status == 409) {
            // else if HTTP_CONFLICT
            console.log('storeCustomer:409', error.response.data);
          } else if (error.response.status == 403) {
            // else if HTTP_FORBIDDEN on enough permissions
            console.log('storeCustomer:403', error.response.data);
          } else if (error.response.status == 401) {
            // else if HTTP_UNAUTHORIZED not authorized
            console.log('storeCustomer:401', error.response.data);
          } else {
            console.log('storeCustomer: Response error', error.response.data, error.response.status, error.response.headers);
          }

        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.error('storeCustomer: Request error', error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.error('storeCustomer: Error', error.message);
        }
      }

      return null;
    },

    selectSelectedCustomer(customerLimitedDataObject) {
      if (this.consoleDebug) console.log('BookingCheckoutIframeCustomer::selectSelectedCustomer', customerLimitedDataObject);
      if (customerLimitedDataObject === null) {
        this.resetCustomerInputs();
      } else {
        this.customerId = customerLimitedDataObject.id;
        this.email = customerLimitedDataObject.email;
        this.customerName = customerLimitedDataObject.name;
        this.name = this.customerName;
        this.contactNumber = '***** ******';
        this.marketingConsent = ! customerLimitedDataObject.no_mail;
      }
    },

    emailBlur() {
      if (this.consoleDebug) console.log('BookingCheckoutIframeCustomer::emailBlur()');
      if (this.customerId !== null && this.email != this.customerEmail) {
        // console.log('emailBlur:forget');
        // you changed the emil address, forgot who we though you where
        this.customerId = null;
        this.customerEmail = null;
        this.customerName = null;
      }

      if (this.email && (this.name == null || this.name == '')) {

        this.emailError = false;
        this.emailSoftError = false;

        try {
          new Address(this.email);
        } catch (error) {
          this.emailError = error.message; // Please enter a valid email address.
          return;
        }
        // console.log('emailBlur:pre searchEmail');
        if (! this.fetchingCustomer) {
          this.loading(true, this.$refs.bookModal);
          this.searchEmail(this.email)
            .then(customerFound => {
              if (this.consoleDebug) console.log('BookingCheckoutIframeCustomer::emailBlur() - searchEmail().then');
              this.loading(false);
              if (customerFound !== null) {
                this.customerId = customerFound.id;
                this.customerEmail = this.email;
                this.customerName = customerFound.name;
                this.name = this.customerName;
                this.contactNumber = '***** ******';
                this.marketingConsent = ! customerFound.no_mail;
                this.awaitingCartUpdate = true;
                this.$emit('customer-selected', customerFound);
                if (this.consoleDebug) console.log('BookingCheckoutIframeCustomer::emailBlur emitted customer-selected', customerFound);
              } else {
                this.$refs.nameInput.focus();
                this.checkRegionalEmail();
              }
            });
        }
      }
    },

    async searchEmail(emailToSearch) {
      if (this.consoleDebug) console.log('async BookingCheckoutIframeCustomer::searchEmail', emailToSearch);

      this.fetchingCustomer = true;

      let request = {
        email: emailToSearch,
      }

      try {
        const response = await axios.post(this.route('api.customers.email-lookup'), request);
        if (response.status == 200) {
          this.fetchingCustomer = false;
          return response.data;
        }
      } catch (error) {
        if (error.response) {
          if (error.response.status == 422) { // HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
            this.emailError = error.response.data.errors.email[0]; // Please enter a valid email address.
          } else if (error.response.status == 404) {
            this.customerId = null;
            this.customerEmail = null;
            this.customerName = null;
          }
          // console.log('emailBlur: Response error', error.response.data, error.response.status, error.response.headers);
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          // console.error('emailBlur: Request error', error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          // console.error('emailBlur: Error', error.message);
        }
      }

      this.fetchingCustomer = false;
      return null;
    },

    checkRegionalEmail() {
      var regex = /^[\w.+\-]+@([a-zA-Z0-9]+)([\.])(com|co.uk)/gm;
      if (regex.test(this.email)) {
        this.emailSoftError = false;
      } else {
        this.emailSoftError = 'Warning: Email does not end in .co.uk or .com. You may proceed with the booking, this is to highlight you have a non-standard email, or a typo.';
      }
    },

    cartRefreshed(cart) {
      if (this.consoleDebug) console.log('BookingCheckoutIframeCustomer::cartRefreshed', cart);
      if (this.awaitingCartUpdate) {
        if (this.consoleDebug) console.log('BookingCheckoutIframeCustomer::cartRefreshed - scrolling to bottom of screen - <-- 2025-04-27 this was removed');
        this.awaitingCartUpdate = false;
        // this.$nextTick(() => {
        //   window.scrollTo(0, document.body.scrollHeight);
        // });
      }
      this.cart = cart;
      if (cart.customer === null && this.sale === null) {
        this.resetCustomerInputs();
      }
    },

    resetCustomerInputs() {
      if (this.consoleDebug) console.log('BookingCheckoutIframeCustomer::resetCustomerInputs');
      this.email = null;
      this.name = null;
      this.username = null;
      this.contactNumber = null;
      this.marketingConsent = false;

      this.emailError = false;
      this.emailSoftError = false;
      this.nameError = false;

      this.awaitingCartUpdate = false;
    },

    emptyCart() {
      if (this.consoleDebug) console.log('BookingCheckoutIframeCustomer::emptyCart');
      this.$emit('empty-cart');
    },

    removeCustomerFromCart() {
      if (this.consoleDebug) console.log('BookingCheckoutIframeCustomer::removeCustomerFromCart');
      this.$emit('remove-customer-from-cart');
    },
  },

  mounted() {
    // watch does not work from the mount
    if (this.selectedCustomer) {
      this.selectSelectedCustomer(this.selectedCustomer);
    }
  },
}
</script>
